import { Warning } from "@phosphor-icons/react";

export default function PaymentDisclaimer({ compact = false }) {
  if (compact) {
    return (
      <div className="flex items-start gap-2 text-[11px] leading-relaxed text-zinc-500 font-body">
        <Warning size={14} weight="bold" className="mt-0.5 shrink-0 text-[#FFD700]" />
        <span>
          Payment is made directly to the seller. Hunt57 does not process, hold, escrow, refund, or guarantee card-sale
          payments.
        </span>
      </div>
    );
  }
  return (
    <div className="border border-[#FFD700]/30 bg-[#FFD700]/5 p-4 flex items-start gap-3">
      <Warning size={20} weight="fill" className="text-[#FFD700] mt-0.5 shrink-0" />
      <div>
        <div className="font-display uppercase text-xs tracking-widest font-bold text-[#FFD700] mb-1">
          Direct Payment Notice
        </div>
        <p className="text-sm text-zinc-300 leading-relaxed">
          Payment is made directly to the seller through their chosen payment path. Hunt57 does not process, hold,
          escrow, refund, or guarantee card-sale payments.
        </p>
      </div>
    </div>
  );
}
